/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService
 */
import * as References from './ContentAssignmentsChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService#assignContent
 */
export const ASSIGN_CONTENT_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_ContentAssignmentsChirpService_assignContent';
export const ASSIGN_CONTENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ASSIGN_CONTENT_MUTATION_FIELD_NAME,
  args: ['contentType', 'contentId', 'targetPortalId', 'assigneeUserIds', 'teamIds', 'dueDate'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.assignContentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService#getContentAssignmentsByIds
 */
export const GET_CONTENT_ASSIGNMENTS_BY_IDS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_ContentAssignmentsChirpService_getContentAssignmentsByIds';
export const GET_CONTENT_ASSIGNMENTS_BY_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CONTENT_ASSIGNMENTS_BY_IDS_QUERY_FIELD_NAME,
  args: ['assignmentId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getContentAssignmentsByIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService#updateContentAssignment
 */
export const UPDATE_CONTENT_ASSIGNMENT_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_ContentAssignmentsChirpService_updateContentAssignment';
export const UPDATE_CONTENT_ASSIGNMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_CONTENT_ASSIGNMENT_MUTATION_FIELD_NAME,
  args: ['assignmentIds', 'dueDate'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.updateContentAssignmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService#deleteContentAssignment
 */
export const DELETE_CONTENT_ASSIGNMENT_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_ContentAssignmentsChirpService_deleteContentAssignment';
export const DELETE_CONTENT_ASSIGNMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_CONTENT_ASSIGNMENT_MUTATION_FIELD_NAME,
  args: ['assignmentId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.deleteContentAssignmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService#search
 */
export const SEARCH_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_ContentAssignmentsChirpService_search';
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['contentType', 'contentId', 'targetPortalId', 'query', 'assignedByRequestingUser', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.ContentAssignmentsChirpService#searchAggregation
 */
export const SEARCH_AGGREGATION_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_ContentAssignmentsChirpService_searchAggregation';
export const SEARCH_AGGREGATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_AGGREGATION_QUERY_FIELD_NAME,
  args: ['contentType', 'contentId', 'query', 'assignedByRequestingUser', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.searchAggregationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});